<div
  class="bg-gray-50 rounded-xl ca-shadow h-full overflow-y-clip overflow-x-clip"
>
  <h2 class="pl-2 pt-2 text-base font-bold text-gray-700 m-0">{{ title }}</h2>
  <div class="overflow-y-auto h-full pb-4 p-2">
    <ng-content></ng-content>
  </div>
</div>
